module.exports = __webpack_public_path__ + "static/media/Email_Free_book_mobile.612c4cc0.jpg";